/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountCustomFields } from './AccountCustomFields';
import {
    AccountCustomFieldsFromJSON,
    AccountCustomFieldsFromJSONTyped,
    AccountCustomFieldsToJSON,
} from './AccountCustomFields';
import type { SignRequestDocument } from './SignRequestDocument';
import {
    SignRequestDocumentFromJSON,
    SignRequestDocumentFromJSONTyped,
    SignRequestDocumentToJSON,
} from './SignRequestDocument';
import type { SignRequestRecipients } from './SignRequestRecipients';
import {
    SignRequestRecipientsFromJSON,
    SignRequestRecipientsFromJSONTyped,
    SignRequestRecipientsToJSON,
} from './SignRequestRecipients';
import type { SignRequestSender } from './SignRequestSender';
import {
    SignRequestSenderFromJSON,
    SignRequestSenderFromJSONTyped,
    SignRequestSenderToJSON,
} from './SignRequestSender';

/**
 * 
 * @export
 * @interface SignRequest
 */
export interface SignRequest {
    /**
     * The URI for retrieving attachments associated with the signing request
     * @type {string}
     * @memberof SignRequest
     */
    attachmentsUri?: string;
    /**
     * The date and time when the signing request was completed
     * @type {string}
     * @memberof SignRequest
     */
    completedDateTime?: string;
    /**
     * The UTC timestamp indicating when the signing request was created
     * @type {string}
     * @memberof SignRequest
     */
    createdDateTime?: string;
    /**
     * Account-level custom fields applied to the signing request. Custom fields help administrators group and manage envelopes within the account
     * @type {AccountCustomFields}
     * @memberof SignRequest
     */
    customFields?: AccountCustomFields;
    /**
     * The URI for retrieving custom fields associated with the signing request
     * @type {string}
     * @memberof SignRequest
     */
    customFieldsUri?: string;
    /**
     *  The date and time when a recipient declined to sign the document
     * @type {string}
     * @memberof SignRequest
     */
    declinedDateTime?: string;
    /**
     * Reserved for DocuSign. Indicates when the envelope was deleted
     * @type {string}
     * @memberof SignRequest
     */
    deletedDateTime?: string;
    /**
     * The date and time when the sign request was delivered to the recipient
     * @type {string}
     * @memberof SignRequest
     */
    deliveredDateTime?: string;
    /**
     * The URI for retrieving all the signing request documents combined into a single PDF file
     * @type {string}
     * @memberof SignRequest
     */
    documentsCombinedUri?: string;
    /**
     * The URI for retrieving all signing request documents as separate filess
     * @type {string}
     * @memberof SignRequest
     */
    documentsUri?: string;
    /**
     * The subject line of the email sent to all recipients
     * @type {string}
     * @memberof SignRequest
     */
    emailSubject?: string;
    /**
     * A list contain information about the documents that are included in the signing request
     * @type {Array<SignRequestDocument>}
     * @memberof SignRequest
     */
    documents?: Array<SignRequestDocument>;
    /**
     * The unique identifier (GUID) of the sign request
     * @type {string}
     * @memberof SignRequest
     */
    id?: string;
    /**
     * The URI for retrieving this envelope or related envelope resources
     * @type {string}
     * @memberof SignRequest
     */
    uri?: string;
    /**
     * The number of days the envelope remains active before it expires. A negative value indicates that the envelope has already expired
     * @type {string}
     * @memberof SignRequest
     */
    expireAfter?: string;
    /**
     * The date and time when the envelope is set to expire
     * @type {string}
     * @memberof SignRequest
     */
    expireDateTime?: string;
    /**
     * Indicates whether custom expiration is enabled. When **true**, the envelope expires after the specified number of days (`expireAfter`). When **false**, the account-level default or DocuSign default (120 days) applies
     * @type {string}
     * @memberof SignRequest
     */
    expireEnabled?: string;
    /**
     * The date and time when the sign request was first sent
     * @type {string}
     * @memberof SignRequest
     */
    initialSentDateTime?: string;
    /**
     * The date and time when the sign request was last modified
     * @type {string}
     * @memberof SignRequest
     */
    lastModifiedDateTime?: string;
    /**
     * TThe URI for retrieving sign request notification settings
     * @type {string}
     * @memberof SignRequest
     */
    notificationUri?: string;
    /**
     * A collection of recipient objects providing details about the envelope’s signers and carbon copy
     * @type {SignRequestRecipients}
     * @memberof SignRequest
     */
    recipients?: SignRequestRecipients;
    /**
     * The URI for retrieving recipient details
     * @type {string}
     * @memberof SignRequest
     */
    recipientsUri?: string;
    /**
     * Information about the sender who initiated the sign request
     * @type {SignRequestSender}
     * @memberof SignRequest
     */
    sender?: SignRequestSender;
    /**
     * The UTC timestamp indicating when the sign request was sent
     * @type {string}
     * @memberof SignRequest
     */
    sentDateTime?: string;
    /**
     * The current status of the sign request (e.g., sent, delivered, completed, declined)
     * @type {string}
     * @memberof SignRequest
     */
    status?: string;
    /**
     * The date and time when the signing request’s status was last updated
     * @type {string}
     * @memberof SignRequest
     */
    statusChangedDateTime?: string;
    /**
     * The date and time when the sign request status was initially set (e.g., when created or sent)
     * @type {string}
     * @memberof SignRequest
     */
    statusDateTime?: string;
    /**
     * The URI for retrieving templates associated with the sign request
     * @type {string}
     * @memberof SignRequest
     */
    templatesUri?: string;
    /**
     * The date and time when the sign request was voided
     * @type {string}
     * @memberof SignRequest
     */
    voidedDateTime?: string;
    /**
     * The reason provided for voiding the sign request
     * @type {string}
     * @memberof SignRequest
     */
    voidedReason?: string;
}

/**
 * Check if a given object implements the SignRequest interface.
 */
export function instanceOfSignRequest(value: object): boolean {
    return true;
}

export function SignRequestFromJSON(json: any): SignRequest {
    return SignRequestFromJSONTyped(json, false);
}

export function SignRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'attachmentsUri': json['attachmentsUri'] == null ? undefined : json['attachmentsUri'],
        'completedDateTime': json['completedDateTime'] == null ? undefined : json['completedDateTime'],
        'createdDateTime': json['createdDateTime'] == null ? undefined : json['createdDateTime'],
        'customFields': json['customFields'] == null ? undefined : AccountCustomFieldsFromJSON(json['customFields']),
        'customFieldsUri': json['customFieldsUri'] == null ? undefined : json['customFieldsUri'],
        'declinedDateTime': json['declinedDateTime'] == null ? undefined : json['declinedDateTime'],
        'deletedDateTime': json['deletedDateTime'] == null ? undefined : json['deletedDateTime'],
        'deliveredDateTime': json['deliveredDateTime'] == null ? undefined : json['deliveredDateTime'],
        'documentsCombinedUri': json['documentsCombinedUri'] == null ? undefined : json['documentsCombinedUri'],
        'documentsUri': json['documentsUri'] == null ? undefined : json['documentsUri'],
        'emailSubject': json['emailSubject'] == null ? undefined : json['emailSubject'],
        'documents': json['documents'] == null ? undefined : ((json['documents'] as Array<any>).map(SignRequestDocumentFromJSON)),
        'id': json['id'] == null ? undefined : json['id'],
        'uri': json['uri'] == null ? undefined : json['uri'],
        'expireAfter': json['expireAfter'] == null ? undefined : json['expireAfter'],
        'expireDateTime': json['expireDateTime'] == null ? undefined : json['expireDateTime'],
        'expireEnabled': json['expireEnabled'] == null ? undefined : json['expireEnabled'],
        'initialSentDateTime': json['initialSentDateTime'] == null ? undefined : json['initialSentDateTime'],
        'lastModifiedDateTime': json['lastModifiedDateTime'] == null ? undefined : json['lastModifiedDateTime'],
        'notificationUri': json['notificationUri'] == null ? undefined : json['notificationUri'],
        'recipients': json['recipients'] == null ? undefined : SignRequestRecipientsFromJSON(json['recipients']),
        'recipientsUri': json['recipientsUri'] == null ? undefined : json['recipientsUri'],
        'sender': json['sender'] == null ? undefined : SignRequestSenderFromJSON(json['sender']),
        'sentDateTime': json['sentDateTime'] == null ? undefined : json['sentDateTime'],
        'status': json['status'] == null ? undefined : json['status'],
        'statusChangedDateTime': json['statusChangedDateTime'] == null ? undefined : json['statusChangedDateTime'],
        'statusDateTime': json['statusDateTime'] == null ? undefined : json['statusDateTime'],
        'templatesUri': json['templatesUri'] == null ? undefined : json['templatesUri'],
        'voidedDateTime': json['voidedDateTime'] == null ? undefined : json['voidedDateTime'],
        'voidedReason': json['voidedReason'] == null ? undefined : json['voidedReason'],
    };
}

export function SignRequestToJSON(value?: SignRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attachmentsUri': value['attachmentsUri'],
        'completedDateTime': value['completedDateTime'],
        'createdDateTime': value['createdDateTime'],
        'customFields': AccountCustomFieldsToJSON(value['customFields']),
        'customFieldsUri': value['customFieldsUri'],
        'declinedDateTime': value['declinedDateTime'],
        'deletedDateTime': value['deletedDateTime'],
        'deliveredDateTime': value['deliveredDateTime'],
        'documentsCombinedUri': value['documentsCombinedUri'],
        'documentsUri': value['documentsUri'],
        'emailSubject': value['emailSubject'],
        'documents': value['documents'] == null ? undefined : ((value['documents'] as Array<any>).map(SignRequestDocumentToJSON)),
        'id': value['id'],
        'uri': value['uri'],
        'expireAfter': value['expireAfter'],
        'expireDateTime': value['expireDateTime'],
        'expireEnabled': value['expireEnabled'],
        'initialSentDateTime': value['initialSentDateTime'],
        'lastModifiedDateTime': value['lastModifiedDateTime'],
        'notificationUri': value['notificationUri'],
        'recipients': SignRequestRecipientsToJSON(value['recipients']),
        'recipientsUri': value['recipientsUri'],
        'sender': SignRequestSenderToJSON(value['sender']),
        'sentDateTime': value['sentDateTime'],
        'status': value['status'],
        'statusChangedDateTime': value['statusChangedDateTime'],
        'statusDateTime': value['statusDateTime'],
        'templatesUri': value['templatesUri'],
        'voidedDateTime': value['voidedDateTime'],
        'voidedReason': value['voidedReason'],
    };
}

